<div class="tracking-container">
  <!-- Back Button -->
  <div class="back-button-section">
    <button
      routerLink="/auth/login"
      class="btn btn-secondary btn-elevate kt-login__btn-secondary back-btn">
      Πίσω
    </button>
  </div>

  <!-- Header Section -->
  <div class="tracking-header text-center">
    <!-- Informative Icon and Message -->
    <div class="info-section">
      <mat-icon class="search-icon large-icon">search</mat-icon>
      <p class="info-text">
        Εισάγετε τον κωδικό παρακολούθησης της αποστολής σας για να δείτε την
        τρέχουσα κατάστασή της
      </p>
    </div>

    <!-- Search Form -->
    <div class="search-section">
      <div class="d-flex align-items-center justify-content-center gap-3">
        <mat-form-field class="search-input">
          <mat-label>Κωδικός Παρακολούθησης</mat-label>
          <input
            matInput
            [formControl]="trackingControl"
            placeholder="Εισάγετε τον κωδικό"
            (keyup.enter)="searchTracking()"
            autocomplete="off" />
          <mat-error *ngIf="trackingControl.hasError('required')">
            Ο κωδικός παρακολούθησης είναι απαραίτητος
          </mat-error>
          <mat-error *ngIf="trackingControl.hasError('minlength')">
            Ο κωδικός πρέπει να έχει τουλάχιστον 5 χαρακτήρες
          </mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          class="btn btn-primary btn-elevate search-btn"
          [disabled]="!isFormValid || isLoading"
          (click)="searchTracking()">
          <mat-icon *ngIf="!isLoading">search</mat-icon>
          <mat-icon *ngIf="isLoading" class="spinning">refresh</mat-icon>
          {{ isLoading ? 'Αναζήτηση...' : 'Αναζήτηση' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Results Section -->
  <div class="tracking-results" *ngIf="hasSearched">
    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-section text-center">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="loading-text">Αναζήτηση αποστολής...</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="error-section text-center">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <p class="error-text">{{ errorMessage }}</p>
    </div>

    <!-- Tracking Timeline -->
    <div *ngIf="trackingResults$ | async as results">
      <perfect-scrollbar class="scroller">
        <div class="tdata" [ngClass]="{ ccenter: isCourierCenter }">
          <ng-container
            *ngFor="
              let stat of results;
              let last = last;
              let even = even;
              let odd = odd
            ">
            <!-- Even items (left side) -->
            <ng-container *ngIf="even">
              <div class="row align-items-center how-it-works">
                <div class="col-2 text-center bottom">
                  <div class="circle">
                    {{ stat._date | date: 'dd/MM/yy HH:mm' }}
                  </div>
                </div>
                <div class="col-10">
                  <h5 class="stats">{{ stat._status }}</h5>
                  <p class="station">{{ stat._station }}</p>
                </div>
              </div>

              <div *ngIf="!last" class="row timeline">
                <div class="col-2">
                  <div class="corner top-right"></div>
                </div>
                <div class="col-8">
                  <hr />
                </div>
                <div class="col-2">
                  <div class="corner left-bottom"></div>
                </div>
              </div>
            </ng-container>

            <!-- Odd items (right side) -->
            <ng-container *ngIf="odd">
              <div
                class="row align-items-center justify-content-end how-it-works">
                <div class="col-10 text-right">
                  <h5 class="stats">{{ stat._status }}</h5>
                  <p class="station">{{ stat._station }}</p>
                </div>
                <div class="col-2 text-center full">
                  <div class="circle">
                    {{ stat._date | date: 'dd/MM/yy HH:mm' }}
                  </div>
                </div>
              </div>

              <div *ngIf="!last" class="row timeline">
                <div class="col-2">
                  <div class="corner right-bottom"></div>
                </div>
                <div class="col-8">
                  <hr />
                </div>
                <div class="col-2">
                  <div class="corner top-left"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</div>
